import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import {ConfirmationService, SelectItem} from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import {AppSettingService} from '../../_services/app-setting.service';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../_models/garantias-idoneas';
import {GarantiaIdoneasService} from '../../_services/garantia-idoneas.service';
import {GarantiasIdoneasDestino} from '../../_models/garantias-idoneas-destino';
import {GarantiaIdoneasDestinosService} from '../../_services/garantia-idoneas-destinos.service';
import {GarantiasIdoneasMunicipio} from '../../_models/garantias-idoneas-municipio';
import {GarantiaIdoneasMunicipioService} from '../../_services/garantia-idoneas-municipio.service';
import {GarantiasIdoneasActividades} from '../../_models/garantias-idoneas-actividades';
import {GarantiaIdoneasActividadesService} from '../../_services/garantia-idoneas-actividades.service';
import {GarantiasIdoneasProducto} from '../../_models/garantias-idoneas-producto';
import {GarantiaIdoneasProductoService} from '../../_services/garantia-idoneas-producto.service';
import {GarantiasIdoneasPeriodoGracia} from '../../_models/garantias-idoneas-periodo-gracia';
import {GarantiasIdoneasPeriodoGraciaConceptoFacturacion} from '../../_models/garantias-idoneas-periodo-gracia-concepto-facturacion';
import {GarantiaIdoneasPeriodoGraciaService} from '../../_services/garantia-idoneas-periodo-gracia.service';
import {GarantiaIdoneasPeriodoGraciaConceptosFacturacionService} from '../../_services/garantia-idoneas-periodo-gracia-conceptos-facturacion.service';
import {TiposProductores} from '../../_models/tipos-productores';
import {GarantiaIdoneasTipoProductoService} from '../../_services/garantia-idoneas-tipo-producto.service';
import {GarantiasIdoneasTipoProductor} from '../../_models/garantias-idoneas-tipo-producto';
import { GarantiasIdoneasCobrosPerfilesRiesgos } from '../../_models/garantias-idoneas-cobros-perfiles-riesgos';
import { GarantiaIdoneaCobrosPerfilesRiesgosService } from '../../_services/garantia-idonea-cobros-perfiles-riesgos.service';
import {ListaItem} from '../../_models/lista-item';
import {ListaService} from '../../_services/lista.service';

@Component( {
  selector: 'app-garantia-idoneas-detalle',
  templateUrl: 'garantia-idoneas-detalle.component.html'
} )

export class GarantiaIdoneasDetalleComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  garantiasIdoneas: GarantiasIdoneas;
  formulario: FormGroup;

  periodoGracia: GarantiasIdoneasPeriodoGracia;

  /** Listas */
  listGarantiasIdoneasDestino: GarantiasIdoneasDestino[] = [];
  listGarantiasIdoneasMunicipio: GarantiasIdoneasMunicipio[] = [];
  listaGarantiasIdoneasActividades: GarantiasIdoneasActividades[] = [];
  listGarantiasIdoneasProducto: GarantiasIdoneasProducto[] = [];
  listGarantiasIdoneasPeriodoConcepto: GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] = [];
  listGarantiasIdoneasTiposProductores: GarantiasIdoneasTipoProductor[] = [];
  lisGarantiaIdoneasCobroPerfil: GarantiasIdoneasCobrosPerfilesRiesgos[] = [];

  /** Listas columnas */
  columnasDestino: any[] = [];
  columnasMunicipio: any[] = [];
  columnasActividades: any[];
  columnasProducto: any[] = [];
  columnasTiposProductores: any[] = [];
  columnasPeriodoGracia: any[] = [];
  columnasConceptos: any[] = [];
  columnasCobroPerfil: any[] = [];
  listasFondosGarantiasTodas: ListaItem[] = [];
  listasFondosGarantias:  SelectItem[] = [];

  constructor( private garIdoneaServices: GarantiaIdoneasService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService,
               public appSettingService: AppSettingService,
               private garantiasIdoneasDestinoServices: GarantiaIdoneasDestinosService,
               private garantiasIdoneasMunicipio: GarantiaIdoneasMunicipioService,
               private garantiasActividades: GarantiaIdoneasActividadesService,
               private garantiasIdoneasProducto: GarantiaIdoneasProductoService,
               private periodoGraciaService: GarantiaIdoneasPeriodoGraciaService,
               private periodoGraciaConceptosService: GarantiaIdoneasPeriodoGraciaConceptosFacturacionService,
               private garantiasIdoneasTipoProductoServices: GarantiaIdoneasTipoProductoService,
               private garIdoneaCobroPerfilService: GarantiaIdoneaCobrosPerfilesRiesgosService,
               private lisServicio: ListaService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.garIdoneaServices.obtenerPorId( params[ 'id' ] ).subscribe(async paquete => {
          this.garantiasIdoneas = paquete;
          this.listasFondosGarantiasTodas = await this.lisServicio.getMasterDetails( 'ListasFondosGarantias' ).toPromise();
          this.listasFondosGarantiasTodas.forEach( e => {
            if ( e.indicadorHabilitado) {
              this.listasFondosGarantias.push( { label: e.nombre, value: e.idLista } );
            }
          } );
          this.cargarInformacionInicial();
        } );
      }
    } );
  }

  cargarInformacionInicial() {


    this.columnasDestino = [
      { field: 'codigoDestinoProducto', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_ID' ), sort: true },
      { field: 'destinoProducto', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_DESTINOS' ), sort: true }
    ];

    this.columnasMunicipio = [
      { field: 'departamento', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_DEPARTAMENTO' ), sort: true },
      { field: 'municipio', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_MUNICIPIO' ), sort: true }
    ];

    this.columnasProducto = [
      { field: 'codigoProducto', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PRODUCTO_CODIGO' ), sort: true },
      { field: 'producto', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PRODUCTO' ), sort: true }
    ];

    this.columnasPeriodoGracia = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOSCODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOSNOMBRE' ), sort: true }
    ];

    this.columnasActividades = [
      { field: 'actividad', header: this.navServicio.buscarMensaje( 'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESSELECCIONADAS' ), sort: true }
    ];

    this.columnasTiposProductores = [
      { field: 'codigoTipoProductor', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORCODIGO' ), sort: true },
      { field: 'tipoProductor', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORNOMBRE' ), sort: true }
    ];

    this.columnasConceptos = [
      { field: 'codigoConceptoFacturacion', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOSCODIGO' ), sort: true },
      { field: 'conceptoFacturacion', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PERIODOCONCEPTOSNOMBRE' ), sort: true }
    ];

    this.columnasCobroPerfil = [
      { field: 'codigoPerfilRiesgo', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PERFILRIESGO' ), sort: true },
      { field: 'porcentajeCobro', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PORCENTAJECOBRO' ), sort: true },
      { field: 'codigoPlanCargo', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_PLANCARGO' ), sort: true }
    ];

    forkJoin(
      this.garantiasIdoneasDestinoServices.listadoPorDestinosActivos(this.garantiasIdoneas.idGarantiaIdonea),
      this.garantiasIdoneasMunicipio.listadoPorMunicipiosActivos(this.garantiasIdoneas.idGarantiaIdonea),
      this.garantiasActividades.listadoPorActividadesActiva(this.garantiasIdoneas.idGarantiaIdonea),
      this.garantiasIdoneasProducto.listadoPorProductoActivo(this.garantiasIdoneas.idGarantiaIdonea),
      this.periodoGraciaService.listadoPorPeriodoGracia(this.garantiasIdoneas.idGarantiaIdonea),
      this.periodoGraciaConceptosService.listadoPorPeriodoConpectoActivos(this.garantiasIdoneas.idGarantiaIdonea),
      this.garantiasIdoneasTipoProductoServices.listadoPorTipoProductoActivos(this.garantiasIdoneas.idGarantiaIdonea),
      this.garIdoneaCobroPerfilService.listadoPorIdGarantiaIdoneaHabilitado(this.garantiasIdoneas.idGarantiaIdonea)
    ).
    subscribe( ( [ destinos, municipios, actividades, productos,
                            periodoGracia, listConceptos, tipoProductor, lisCobroPerfil ] ) => {
      this.listGarantiasIdoneasDestino = destinos;
      this.listGarantiasIdoneasMunicipio = municipios;
      this.listaGarantiasIdoneasActividades = actividades;
      this.listGarantiasIdoneasProducto = productos;
      this.periodoGracia = periodoGracia;
      this.listGarantiasIdoneasPeriodoConcepto = listConceptos;
      this.listGarantiasIdoneasTiposProductores = tipoProductor;
      this.lisGarantiaIdoneasCobroPerfil = lisCobroPerfil;
      this.carInformacionInicial = false;
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );
  }



  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: `garantia-idoneas`,
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }


}
